import { useLoading } from 'vue-loading-overlay';

const LoadingPluginCustom = (app) => {

    function UseLoadingCustom() {

        var loadingBaborsh = null;
        var loading = useLoading({ enforceFocus: false });

        function blockKey(e) {
            if (e.ctrlKey || e.altKey || e.metaKey || /^F\d+$/.test(e.key)) return;
            e.preventDefault();
            e.stopPropagation();
        }

        return {

            show() {

                if (loadingBaborsh == null) {
                    loadingBaborsh = loading.show();
                    document.addEventListener('keydown', blockKey, true);

                    // Se comenta porque me jode los autocompletes
                    //if (document.activeElement) document.activeElement.blur();
                }

            },

            hide() {

                if (loadingBaborsh != null) {

                    loadingBaborsh.hide();
                    loadingBaborsh = null;
                    document.removeEventListener('keydown', blockKey, true);

                }

            }

        }
    }


    const instance = UseLoadingCustom();

    app.config.globalProperties.$loading = instance;
    app.provide('$loading', instance)



};

export { LoadingPluginCustom };
